import { render, staticRenderFns } from "./SignedBankCard.vue?vue&type=template&id=6af183e2&scoped=true&"
import script from "./SignedBankCard.vue?vue&type=script&lang=js&"
export * from "./SignedBankCard.vue?vue&type=script&lang=js&"
import style0 from "./SignedBankCard.vue?vue&type=style&index=0&id=6af183e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af183e2",
  null
  
)

export default component.exports